import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=fa0b5878&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa0b5878')) {
      api.createRecord('fa0b5878', component.options)
    } else {
      api.reload('fa0b5878', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=fa0b5878&", function () {
      api.rerender('fa0b5878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2l4tHitJsCT70/JS/comp/IncreaseNumber.vue"
export default component.exports